import React, {useEffect, useMemo, useState} from 'react'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
// import AssignStaffPopup from './ProfilePageComponent/AssignStaffPopup'

import {KTSVG, useDebounce} from '../../../../../../_metronic/helpers'

import DeleteConfirmationPopup from '../../../../../Components/DeleteConfirmationPopup'
import {getUserData} from '../../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {
  getAllUSerOfWhiteLabel,
  GetAllUSerOfWhiteLabel,
} from '../WhiteLabelProfileSlice/WhiteLAbelSlice'

const WhiteLabelUserList = () => {
  const dispatch = useDispatch()
  const [assign, setAssign] = useState(false)
  const ProfileDetatileState = useSelector(
    (state: any) => state?.ProfileData?.ProfileData?.items?.[0]
  )
  const AssigneUserOfWhiteLabelList = useSelector(getAllUSerOfWhiteLabel)
  console.log(ProfileDetatileState, 'ppppppppppppppppppp')

  const param = useLocation()
  const Role = useSelector(getUserData)

  //   const List = useSelector(getAllUserAssignedToStaffList)

  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deallocate, setDeallocate] = useState({
    userId: ProfileDetatileState?._id,
    staffId: '',
  })
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })

  const [assignTo, setAssignTo] = useState({
    userId: ProfileDetatileState?._id,
    accountManagerId: '',
    salesId: '',
  })

  const debouncedSearchTerm = useDebounce(page?.search, 3000)

  useEffect(() => {
    dispatch(GetAllUSerOfWhiteLabel({accountId: ProfileDetatileState?.accountId, ...page}))
  }, [debouncedSearchTerm, page.page, page.size])

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete this whitelabel user?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  return (
    <>
      {confirmation}
      {/* {AssignStaff} */}
      <div className={`sub-accountstable card `}>
        <div className='card'>
          <div className='card-body'>
            <div className='d-flex flex-wrap flex-sm-nowrap'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <a className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                        Assigned User
                      </a>
                    </div>
                  </div>

                  <div className='d-flex mb-3'>
                    {
                      <div
                        className='card-toolbar'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title='Click to add a user'
                      >
                        <div className='d-flex align-items-center position-relative my-1'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen021.svg'
                            className='svg-icon-1 position-absolute ms-6'
                          />
                          <input
                            type='text'
                            data-kt-user-table-filter='search'
                            className='form-control form-control-solid w-250px ps-14'
                            placeholder='Search user'
                            value={page?.search}
                            onChange={(e) => setPage({...page, search: e.target.value})}
                          />
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th className='min-w-150px'>USER</th>

                  <th className='min-w-150px'>CREATED ON</th>
                </tr>
              </thead>
              <tbody>
                {AssigneUserOfWhiteLabelList?.items?.map((data: any, id: number) => (
                  <tr key={id}>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div
                          // onClick={() => navigate('/user-profile', {state: [data, 'user']})}
                          className='symbol symbol-45px me-5'
                        >
                          <span className='circle1'>{`${
                            data?.firstName !== undefined && data?.firstName !== ''
                              ? data?.firstName?.split('')[0]?.toUpperCase()
                              : ''
                          }${
                            data?.lastName !== undefined && data?.lastName !== ''
                              ? data?.lastName?.split('')[0]
                              : ''
                          }`}</span>
                        </div>
                        <div className='d-flex justify-content-start flex-column'>
                          <a className='text-dark fw-bolder text-hover-primary fs-6'>
                            {`${data?.firstName} ${data?.lastName}`}
                          </a>
                          <span className='text-muted fw-bold text-muted d-block fs-7'>
                            {data?.email}
                          </span>
                        </div>
                      </div>
                    </td>
                    {ProfileDetatileState?.role === 'owner' && <td>{data?.role}</td>}
                    <td>
                      <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                        {moment(data?.createdAt).format('DD/MM/YYYY')}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* {ProfileDetatileState?.role !== 'owner' && (
              <div className='abcd '>
                <select
                //  onChange={(e: any) => setPage({...page, size: e.target.value})}
                >
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option>ALl</option>
                </select>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={List?.totalPages}
                  onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  )
}

export default WhiteLabelUserList
